import type { TransactionItem } from '@/types/Transaction'

/**
 * Calculates the line total for a transaction item
 * @param item Transaction item
 * @returns Calculated line total
 */
export function calculateLineTotal(item: TransactionItem): number {
  const price = parseFloat(item.price_per_lb.toString()) || 0
  const weight = item.weight?.net != null ? parseFloat(item.weight.net.toString()) : 0
  return parseFloat((price * weight).toFixed(2))
}

/**
 * Calculates the total weight of all items
 * @param items Array of transaction items
 * @returns Total weight
 */
export function calculateTotalWeight(items: TransactionItem[]): number {
  return items.reduce((total, item) => total + (item.weight?.net || 0), 0)
}
